import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { login } from '../services/authService';
import { useAuth } from '../context/AuthContext';

const LoginButton = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false)
  const { state, dispatch } = useAuth();
  
  useEffect(() => {
    if (state.isAuthenticated) {
      navigate('/assessment');
    }
  }, [state.isAuthenticated, navigate]);


  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);


    try {
      const response = await login({ username: email, password });
      if (response && response.token) {
        dispatch({
          type: 'LOGIN',
          payload: { token: response.token }
        });
        window.location.reload();
      } else {
        setError('Login failed. Please try again.');
      }
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div className="navFixMargin flex  lg:p-20 lg:px-24 p-4 rounded-lg">
      {/* Background Image Section for Large Screens */}
      <div className="hidden md:block w-1/2 bg-cover bg-center" style={{ backgroundImage: `url("https://media.licdn.com/dms/image/v2/C5612AQHPI7RWFQuoiw/article-cover_image-shrink_720_1280/article-cover_image-shrink_720_1280/0/1586900654731?e=2147483647&v=beta&t=dWLBmBjd9s9ikFWcAIgfBWIWPbl73_ecbFeaphCZtDs")` }}>
        <div className="flex items-start justify-start p-5 pt-8 h-full bg-black bg-opacity-50">
          <h1 className="text-white text-2xl font-poppins">Welcome back to your Executive Presence Journey!
          </h1>
        </div>
      </div>

      {/* Login Form Section */}
      <div className="w-full md:w-1/2 bg-blue-50 flex items-center justify-center">
        <div className="w-3/4">
          <h2 className="text-3xl font-bold mb-4 font-poppins">Log In</h2>
          <form onSubmit={handleSubmit}>
            <div className="mb-4">
              <label className="block text-gray-700 mb-2" htmlFor="email">Email</label>
              <div className="relative">
                <input
                  required
                  className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-600"
                  type="text"
                  id="email"
                  placeholder="Enter your Email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
                <i className="fas fa-user absolute right-3 top-3 text-gray-400"></i>
              </div>
            </div>
            <div className="mb-4">
              <label className="block text-gray-700 mb-2" htmlFor="password">
                Password
              </label>
              <div className="relative">
                <input
                  className="w-full px-4 py-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-600"
                  type={showPassword ? "text" : "password"}
                  id="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Enter your Password"
                  required
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="absolute right-3 top-3 text-gray-400 focus:outline-none"
                >
                  {showPassword ? (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-5 w-5"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                      <circle cx="12" cy="12" r="3" />
                    </svg>
                  ) : (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-5 w-5"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M13.875 18.825A10.05 10.05 0 0 1 12 19c-7 0-11-7-11-7a15.27 15.27 0 0 1 5.28-5.418M10.61 6.61A10.05 10.05 0 0 1 12 5c7 0 11 7 11 7a15.27 15.27 0 0 1-2.385 2.978" />
                      <line x1="1" y1="1" x2="23" y2="23" />
                    </svg>
                  )}
                </button>
              </div>
            </div>

            {error && <div className="mb-4 text-red-500">{error}</div>}
            <div className="lg:flex items-center justify-between mb-6">
              <label className="flex items-center">
                <input type="checkbox" className="form-checkbox text-blue-600" />
                <span className="ml-2 text-gray-700 mb-1">Remember Me</span>
              </label>
              <Link to="/forgot-password" className="text-gray-600">Forget password?</Link>
            </div>
            <button type="submit" className="w-full bg-blue-600 text-white py-2 rounded-lg hover:bg-blue-700">Log In</button>
          </form>
          <p className="mt-6 text-center text-gray-600">Don’t have an Account? <Link to="/signup" className="text-blue-600">Sign Up</Link></p>
          <p className="text-center mt-4">Your data is secure with us.
          </p>
        </div>
      </div>
    </div>
  );
};

export default LoginButton;
